import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { JobPostingContext } from '../../../contexts/JobPostingContext';
import { EditableJobPostingField } from '../EditableJobPostingField/EditableJobPostingField';

export const JobPostingContent = observer(() => {

  const { shouldRenderJobPostingField, editorModeActive, activeJobPosting } = useContext(JobPostingContext);

  return (
    <div className="ptp-job-posting__content-wrapper">
      <div className="ptp-hidden__xs-down">
        {
          shouldRenderJobPostingField('title') && (
            <div className="ptp-common__section">
              {editorModeActive && <h3 className="ptp-common__heading-brand">Job Title <span className="p2p-field__label--required"> *</span></h3>}
              <EditableJobPostingField
                className="ptp-job-posting__job-title"
                jpKey="title"
                required
                type="text"
                maxLength={50}
                errorText="Please provide a title"
              />
            </div>
          )
        }
      </div>
      {
        shouldRenderJobPostingField('jobDescription') && (
          <div className="ptp-common__section">
            <h3 className="ptp-common__heading-brand">Job Description {editorModeActive && <span className="p2p-field__label--required"> *</span>}</h3>
            <EditableJobPostingField
              jpKey="jobDescription"
              type="rte"
              errorText="Please provide details about this job"
              placeholder="Please provide details about this job and the requirements you are seeking..."
            />
          </div>
        )
      }
      {
        shouldRenderJobPostingField('educationAndSkills') && (
          <div className="ptp-common__section">
            <h3 className="ptp-common__heading-brand">Required Skills and Education</h3>
            <EditableJobPostingField
              jpKey="educationAndSkills"
              type="textarea"
            />
          </div>
        )
      }
      {
        shouldRenderJobPostingField('benefits') && (
          <div className="ptp-common__section">
            <h3 className="ptp-common__heading-brand">Employee Benefits</h3>
            <EditableJobPostingField
              jpKey="benefits"
              type="benefits"
              label="Employee Benefits"
              value={activeJobPosting?.benefits}
            >
              <ul className="ptp-job-posting__benefits-list">
                {activeJobPosting?.benefits?.choices?.filter((benefit) => benefit !== 'Other').map((benefit) => (
                  <li key={benefit}>{benefit}</li>
                ))}

                {activeJobPosting?.benefits?.choices?.includes('Other') && activeJobPosting?.benefits?.other && (
                  <li>
                  Other Benefits: {activeJobPosting?.benefits?.other}
                  </li>
                )}
              </ul>
            </EditableJobPostingField>
          </div>
        )
      }
      {
        shouldRenderJobPostingField('companyDescription') && (
          <div className="ptp-common__section">
            <h3 className="ptp-common__heading-brand">About {activeJobPosting.companyName}</h3>
            <EditableJobPostingField
              jpKey="companyDescription"
              type="textarea"
            />
          </div>
        )
      }
    </div>
  );

});
